import classnames from 'clsx';

import style from './other-shipping-options-section.module.less';
import FulfillmentPlannerContextDrivenOtherShippingOptions from '../../../../fulfillment-planner/other-shipping-options';
import orderDetailsOSOStyle from '../../../../orders/order-details/fulfillment-plan/sections/other-shipping-options/other-shipping-options.module.less';
import OtherShippingOptionsStyleContextProvider from '../../../../orders/other-shipping-options/style-provider';
import sectionStyle from '../orders-sidebar-section.module.less';

import textStyle from 'ui-components/components/text/text.module.less';

const styleContextValue = {
  classes: {
    collapsibleSection: sectionStyle['order-sidebar-section'],
    collapsibleSectionHeaderContent: classnames(sectionStyle['orders-sidebar-section-header-content'], textStyle.h4),
    collapsibleSectionContent: sectionStyle['order-sidebar-section-default-padding'],
    collapsibleSectionCaretIcon: sectionStyle['order-sidebar-section-caret'],
    collapsibleSectionGrabberIcon: sectionStyle['order-sidebar-section-grabber-icon'],
    form: orderDetailsOSOStyle.form,
    sectionTitle: classnames(orderDetailsOSOStyle['section-title'], textStyle.label),
    optionSection: orderDetailsOSOStyle['option-section'],
    billToRow: orderDetailsOSOStyle['bill-to-row'],
    billToDropdown: orderDetailsOSOStyle['bill-to-dropdown'],
    readonlyRow: orderDetailsOSOStyle['read-only-row'],
    readonlyValueSection: classnames(orderDetailsOSOStyle['read-only-value-section'], textStyle.paragraph),
    headerPillsContainer: style['header-pills-container'],
    headerPill: sectionStyle['orders-sidebar-section-header-chip'],
  },
  shouldInputsBeFullWidth: true,
};

/**
 * @param {object} props
 * @param {boolean} props.isExternalFulfillment
 * @param {boolean} props.shouldShowShippingOptions
 * @param {boolean} props.isReadOnly
 * @param {object} props.dragHandleProps
 * @returns {JSX.Element|null}
 */
export const OtherShippingOptionsSection = ({ isExternalFulfillment, shouldShowShippingOptions, isReadOnly, dragHandleProps }) => {
  if (!shouldShowShippingOptions || isExternalFulfillment) {
    return null;
  }

  return (
    <OtherShippingOptionsStyleContextProvider value={styleContextValue}>
      <FulfillmentPlannerContextDrivenOtherShippingOptions
        dragHandleProps={dragHandleProps}
        headerClassName={sectionStyle['orders-sidebar-section-header']}
        isReadOnly={isReadOnly}
      />
    </OtherShippingOptionsStyleContextProvider>
  );
};
